import authorizedRequest from 'api/request/authorizedRequest';
import { PREFIX_API } from 'constants/api.const';
import { preprocessGetQuery } from 'helpers/api.helper';
import { getFormData } from 'helpers/form-data.helper';
import {
  ActiveMemberRequestModel,
  ActiveMemberResponseModel,
  DeleteMemberRequestModel,
  DeleteMemberResponseModel,
  GetMemberRequestModel,
  GetMemberResponseModel,
  InactiveMemberRequestModel,
  InactiveMemberResponseModel,
  ListMemberRequestModel,
  ListMemberResponseModel,
  SaveMemberRequestModel,
  SaveMemberResponseModel,
} from 'models/setting/member.model';

export function getMember(payload: GetMemberRequestModel) {
  if (payload?.id) {
    return authorizedRequest.get<
      GetMemberResponseModel,
      GetMemberResponseModel
    >(`${PREFIX_API.GENERAL}/customers/${payload?.id}`);
  }
}

export function listMember(payload: ListMemberRequestModel) {
  return authorizedRequest.get<
    ListMemberResponseModel,
    ListMemberResponseModel
  >(`${PREFIX_API.GENERAL}/customers?${preprocessGetQuery(payload)}`);
}

export function createMember(payload: SaveMemberRequestModel) {
  const formDataPayload = getFormData(payload);

  return authorizedRequest.post<
    SaveMemberResponseModel,
    SaveMemberResponseModel
  >(`${PREFIX_API.GENERAL}/customers`, formDataPayload, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
}

export function updateMember(payload: SaveMemberRequestModel) {
  const formDataPayload = getFormData(payload);

  if (payload?.id) {
    return authorizedRequest.put<
      SaveMemberResponseModel,
      SaveMemberResponseModel
    >(`${PREFIX_API.GENERAL}/customers/${payload?.id}`, formDataPayload, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }
}

export function deleteMember(payload: DeleteMemberRequestModel) {
  return authorizedRequest.delete<
    DeleteMemberResponseModel,
    DeleteMemberResponseModel
  >(`${PREFIX_API.GENERAL}/customers/${payload?.id}`);
}

export function inactiveMember(payload: InactiveMemberRequestModel) {
  return authorizedRequest.put<
    InactiveMemberResponseModel,
    InactiveMemberResponseModel
  >(`${PREFIX_API.GENERAL}/customers/${payload?.id}/inactive`);
}

export function activeMember(payload: ActiveMemberRequestModel) {
  return authorizedRequest.put<
    ActiveMemberResponseModel,
    ActiveMemberResponseModel
  >(`${PREFIX_API.GENERAL}/customers/${payload?.id}/active`);
}
